import React, { useState } from "react"
import InformationTable from "components/Shared/InformationTable"
import {
	ID_INFORMATION_TABLE_CUSTOMER_PROFILING,
	SEGMENT_OPTIONS,
	SegmentName,
	SelectSegment,
	tableHeaders,
} from "components/CustomerBehavior/CustomerProfiling/Shared/utils"
import { IntlShape } from "react-intl/lib"
import { useIntl } from "react-intl"
import GenerateRowsTable from "components/CustomerBehavior/CustomerProfiling/MetricsBySegments/GenerateRowsTable"
import { Select } from "components/Shared/Select"
import { CustomerProfilingTable } from "../service"
import DescriptionTable from "components/CustomerBehavior/CustomerProfiling/MetricsBySegments/DescriptionTable"

interface MetricsBySegmentsProps {
	data: Array<CustomerProfilingTable>
	metricSegment: SegmentName
	setMetricSegment: (segment: SegmentName) => void
	segmentSelected: string
	isIndividual?: boolean
}

export const MetricsBySegments: React.FC<MetricsBySegmentsProps> = ({
	data,
	metricSegment,
	setMetricSegment,
	isIndividual = false,
}) => {
	const intl = useIntl()
	const [dataTable, setDataTable] = useState<Array<CustomerProfilingTable>>(
		data
	)

	const createOptionsSelect = (
		options: Array<SelectSegment>,
		intl: IntlShape
	) => {
		return options.map(({ code, id }) => ({
			code: code,
			name: intl.formatMessage({ id }),
		}))
	}

	return (
		<>
			{!isIndividual && (
				<div className="select-segment">
					<Select
						id="select-segment"
						options={createOptionsSelect(SEGMENT_OPTIONS, intl)}
						label={intl.formatMessage({
							id:
								"phronesis.customerbehavior.application.customerProfiling.metricsBySegments.select",
						})}
						value={metricSegment}
						onChange={(option) => {
							setMetricSegment(option.code as SegmentName)
						}}
					/>
				</div>
			)}
			<div className="table-customer-segmentation">
				<InformationTable
					id={ID_INFORMATION_TABLE_CUSTOMER_PROFILING}
					data={dataTable}
					columnsHeader={columnsHeader(tableHeaders, intl)}
					hasSorting
					onSort={(data) => setDataTable(data)}
					rowsBody={<GenerateRowsTable data={dataTable} />}
				/>
			</div>
			<DescriptionTable />
		</>
	)
}

const columnsHeader = (tableHeaders: Array<string>, intl: IntlShape) => {
	return tableHeaders.map((header: string) => {
		return {
			name: intl.formatMessage({
				id: `phronesis.customerbehavior.application.customerProfiling.metricsBySegments.table.header.${header}`,
			}),
			alignment: "left",
			nameColumnSort: header,
			hasSort: true,
		}
	})
}
